import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { scrollToId } from "./SmoothScroll";

const LINKS = [
  { label: "Leistungen", id: "leistungen" },
  { label: "Arbeiten", id: "arbeiten" },
  { label: "Prozess", id: "prozess" },
  { label: "Stimmen", id: "stimmen" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "border-b border-black/10 bg-[#f4f1ea]/80 backdrop-blur-xl" : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-[1360px] items-center justify-between px-5 py-4 md:px-10">
        <button
          data-testid="logo-button"
          onClick={() => go("top")}
          className={`flex items-center gap-2.5 font-display text-xl tracking-tight ${scrolled ? "text-ink" : "text-white"}`}
        >
          <span className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-white shadow-sm">
            <img src="/logo.webp" alt="IYM – I'm Your Man Logo" className="h-10 w-10 object-contain" />
          </span>
          <span className="hidden sm:inline">Im&nbsp;Your&nbsp;Man</span>
        </button>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className={`group relative font-mono text-xs uppercase tracking-[0.12em] transition-colors ${
                scrolled ? "text-[#4a453d] hover:text-ink" : "text-white/75 hover:text-white"
              }`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#2c3bff] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button
            data-testid="header-contact-button"
            onClick={() => go("kontakt")}
            className="btn-fill hidden items-center gap-2 rounded-full bg-[#2c3bff] px-5 py-2.5 font-display text-xs uppercase tracking-wide text-white sm:flex"
          >
            Angebot holen
            <ArrowUpRight className="h-4 w-4" />
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className={`flex h-10 w-10 items-center justify-center rounded-full border md:hidden ${
              scrolled ? "border-black/10 text-ink" : "border-white/25 text-white"
            }`}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-black/10 bg-[#f4f1ea] px-5 py-4 md:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className="rounded-lg px-3 py-3 text-left font-display text-lg text-ink hover:bg-black/5"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go("kontakt")}
              className="mt-2 rounded-full bg-[#2c3bff] px-5 py-3 text-center font-display text-sm uppercase text-white"
            >
              Angebot holen
            </button>
          </div>
        </div>
      )}
    </motion.header>
  );
}
